import { Component, computed, inject, OnInit } from '@angular/core';
import { SessionStorageService } from 'src/app/services/session-storage.service';
import { CustomRouteMobileViewsStateService } from '../../services/custom-route-mobile-views-state.service';
import { NewChatBotComponent } from 'src/chatbot/chatbot.component';
import { ChatBotScriptService } from 'src/app/services/chatbot.service';
import { ScrollService } from 'src/app/services/scroll.service';

@Component({
  selector: 'app-chatbot-custom-route-mobile',
  standalone: true,
  imports: [
    NewChatBotComponent
  ],
  templateUrl: './chatbot-custom-route-mobile.component.html',
  styleUrls: ['./chatbot-custom-route-mobile.component.scss'],
})
export class ChatbotCustomRouteMobileComponent  implements OnInit {
  private _customRouteMobileViewsState = inject(CustomRouteMobileViewsStateService);
  private _sessionStorageService = inject(SessionStorageService);
  private _chatbotScriptService = inject(ChatBotScriptService);
  private _scrollService = inject(ScrollService);
  
  private readonly _mobileViewsState = computed(() => this._customRouteMobileViewsState.mobileViewsState());
  private readonly _chatId = computed(() => this._chatbotScriptService.chatId());
  get chatId() {
    // TODO: El CHATID VENDRÁ DEL ENDPOINT DE CUSTOM ROUTE
    return this._chatId();
  }

  ngOnInit(): void {
    this._sessionStorageService.setItem('customRouteMobileViewsState', this._mobileViewsState());
    
    // set isScrolled to false due to the actions affected by the scroll is only for the planner view
    this._scrollService.isScrolled.set(false);
  }
}
